export default __webpack_public_path__ + "static/media/img999.23614a7c.png";